







































































































































































































































import Component, { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import RecurrenceUtils from "../utils/recurrenceUtils";
import { Rapport } from "@/shared/Rapport";
import { Groupe } from "@/shared/Groupe";
import RapportMixin from "@/mixins/rapportMixin";
import ErrorMixin from "@/mixins/errorMixins";
import _ from "lodash";
import ListeGroupes from "@/components/listeGroupes.vue";
import moment from "moment/moment";

@Component({
  components: { ListeGroupes },
})
export default class Arcole extends mixins(
  MobileMixin,
  RapportMixin,
  ErrorMixin
) {
  public restaurantIds: any = [];
  public siteNames: any = {};
  public showDateChooser: boolean = false;
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];
  public myDate: any = new Date();
  public myDateBuff: string = new Date().toISOString().substr(0, 10);
  public renderStatus: boolean = false;
  public renderSites: any;
  public group: string = "TOUS";
  public searchTxt: string = "";
  public loading: boolean = false;
  public siteSelected: any;

  public async created() {
    await this.init();
  }

  public async init(realInit: boolean = true) {
    const startDate = new Date(this.dates[0]);
    if (realInit) {
      startDate.setDate(startDate.getDate() - 1);
    }
    this.restaurantIds = [];
    await this.sites.forEach(async (site: any) => {
      if (!this.restaurantIds.includes(site.restaurantId)) {
        this.restaurantIds.push(site.restaurantId);
        this.siteNames[site.restaurantId] = site.libelle;
        await this.arcoleStatus(startDate.toISOString().substr(0, 10), site);
      }
    });
    // console.log(this.siteNames);
    this.renderSites = this.sites.filter(
      (site: any) =>
        site.groupe[0] === this.group ||
        site.groupe.length === 0 ||
        this.group === "TOUS"
    );
  }

  /* public getStatus(id: any) {
    return this.restaurantStatus[id] ? this.restaurantStatus[id] : "??";
  }*/

  public async arcoleStatus(date: any, restaurant: any) {
    await RecurrenceUtils.getArcoleStatus(date, restaurant.restaurantId).then(
      (res: any) => {
        restaurant.status = res.status;
      }
    );
    return;
  }

  public changeRenderStatus() {
    this.renderStatus = !this.renderStatus;
  }

  public async relancerExport(restaurant: any) {
    let startDate = new Date(this.dates[0]);
    let endDate = new Date(this.dates[1]);
    const exportDates = [];

    if (startDate > endDate) {
      const temp = startDate;
      startDate = endDate;
      endDate = temp;
    }

    if (this.dates.length > 1 && endDate !== startDate) {
      const dateToAdd = new Date(startDate);
      while (dateToAdd <= endDate) {
        exportDates.push(dateToAdd.toISOString().substr(0, 10));
        dateToAdd.setDate(dateToAdd.getDate() + 1);
      }
    } else {
      exportDates.push(startDate.toISOString().substr(0, 10));
    }
    await Promise.all(
      exportDates.map(async (date) => {
        await RecurrenceUtils.relanceExport(date, restaurant.restaurantId).then(
          (res: any) => {
            /* */
          }
        );
        await this.arcoleStatus(date, restaurant);
      })
    );

    this.changeRenderStatus();
    return;
  }

  public changeGroup(gr: any) {
    this.group = gr;
    // console.log(this.group);
    if (gr) {
      if (gr !== "TOUS") {
        this.renderSites = this.sites.filter((site: any) => {
          return site.groupe.indexOf(gr) !== -1;
        });
      } else {
        this.renderSites = this.sites;
      }
    }
    if (this.searchTxt.trim() !== "") {
      this.renderSites = this.renderSites.filter((site: any) => {
        return (
          site.libelle.includes(this.searchTxt.toUpperCase()) ||
          site.restaurantId.toString().includes(this.searchTxt)
        );
      });
    }
    this.renderSites = _.orderBy(this.renderSites, "status");
  }

  public async customExport(isCSV: boolean) {
    let startDate = new Date(this.dates[0]);
    let endDate = new Date(this.dates[1]);
    this.loading = true;
    const exportDates = [];

    if (startDate > endDate) {
      const temp = startDate;
      startDate = endDate;
      endDate = temp;
    }

    if (this.dates.length > 1 && endDate !== startDate) {
      const dateToAdd = new Date(startDate);
      while (dateToAdd <= endDate) {
        exportDates.push(dateToAdd.toISOString().substr(0, 10));
        dateToAdd.setDate(dateToAdd.getDate() + 1);
      }
    } else {
      exportDates.push(startDate.toISOString().substr(0, 10));
    }
    for (const date of exportDates) {
      await this.exportWithDates(date, this.siteSelected.restaurantId, isCSV);
    }

    this.loading = false;
  }

  public async exportWithDates(
    date: string,
    restaurantId: number,
    fileType: boolean
  ) {
    await RecurrenceUtils.customExport(
      moment(date).format("YYYY-MM-DD"),
      restaurantId,
      fileType
    ).then();
  }

  get sites(): any {
    return this.$store.getters["login/sites"];
  }

  get rapport(): Rapport {
    return this.$store.getters["rapport/rapport"];
  }

  get groupements(): Groupe[] {
    return this.$store.getters["login/groupements"];
  }
}
